module.exports = __webpack_public_path__ + "static/media/right-arrow.00047c0a.svg";